import css from './styles.module.scss'
import classnames from 'classnames/bind'
import Img from "next/legacy/image"
import TableGroup from './TableGroup'

const cx = classnames.bind(css)

const comparatorAdapter = (firstCMS, secondCMS) => {
  let result = []
  firstCMS.field.forEach((cmsField) => {
    const secondField = secondCMS.field.find(
      (secondCMSField) =>
        secondCMSField.name.toLowerCase() === cmsField.name.toLowerCase()
    )
    let exists = 0
    const temporaryResult = result.map((element) => {
      if (element?.category.toLowerCase() === cmsField.category.toLowerCase()) {
        exists++
        element.fields.push({
          name: cmsField.name,
          firstCMS: {
            mark: cmsField?.mark,
            text: cmsField?.text,
          },
          secondCMS: {
            mark: secondField?.mark,
            text: secondField?.text,
          },
        })
      }
      return element
    })
    if (exists) {
      result = temporaryResult
    } else {
      result = [
        ...result,
        {
          category: cmsField.category,
          fields: [
            {
              name: cmsField.name,
              firstCMS: {
                mark: cmsField?.mark,
                text: cmsField?.text,
              },
              secondCMS: {
                mark: secondField?.mark,
                text: secondField?.text,
              },
            },
          ],
        },
      ]
    }
  })
  return result
}

const ComparatorsTable = ({ firstCMS, secondCMS }) => {
  const categories = comparatorAdapter(firstCMS, secondCMS)
  return (
    <div className={cx(css.table)}>
      <div className={cx(css.head, css.row)}>
        <div className={cx(css.firstCMS, css.cell)}>
          <div className={css.logo}>
            <Img
              src={firstCMS.logo}
              alt={firstCMS.name}
              objectFit="contain"
              layout="fill"
            />
          </div>
        </div>
        <div className={cx(css.secondCMS, css.cell)}>
          <div className={css.logo}>
            <Img
              src={secondCMS.logo}
              alt={secondCMS.name}
              objectFit="contain"
              layout="fill"
            />
          </div>
        </div>
      </div>
      <div className={css.tableBody}>
        {categories &&
          categories.map((category, index) => (
            <TableGroup
              key={index}
              open={index === 0}
              category={category.category}
              fields={category.fields}
            />
          ))}
      </div>
    </div>
  )
}

export default ComparatorsTable
